// ไฟล์: frontend/src/pages/admin/Students.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';
import Chart from 'chart.js/auto';
import { DEFAULT_AVATAR } from '../../assets/default_avatar';

function AdminStudents() {
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    student_id: '',
    first_name: '',
    last_name: '',
    gender: 'male',
    birth_date: '',
    address: '',
    phone: '',
    email: '',
    class_id: '',
    profile_pic: null,
    weight: '', // เพิ่มฟิลด์น้ำหนัก
    height: ''  // เพิ่มฟิลด์ส่วนสูง
  });
  const [formMode, setFormMode] = useState('add'); // 'add' หรือ 'edit'
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [growthHistory, setGrowthHistory] = useState([]);
  const [showGrowthModal, setShowGrowthModal] = useState(false);
  const [growthChart, setGrowthChart] = useState(null);
  
  useEffect(() => {
    fetchStudents();
    fetchClasses();
  }, []);
  
  // ทำลายกราฟเมื่อคอมโพเนนต์ถูกตัดออก
  useEffect(() => {
    return () => {
      if (growthChart) {
        growthChart.destroy();
      }
    };
  }, [growthChart]);
  
  const fetchStudents = async () => {
    try {
      setIsLoading(true);
      const response = await api.student.getAllStudents();
      setStudents(response.data.data || []);
    } catch (error) {
      console.error('Error fetching students:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลนักเรียนได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const fetchClasses = async () => {
    try {
      const response = await api.class.getAllClasses();
      setClasses(response.data.data || []);
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };
  
  const handleShowAddModal = () => {
    setFormData({
      id: '',
      student_id: '',
      first_name: '',
      last_name: '',
      gender: 'male',
      birth_date: '',
      address: '',
      phone: '',
      email: '',
      class_id: '',
      profile_pic: null,
      weight: '',
      height: ''
    });
    setPreviewImage(null);
    setFormMode('add');
    setShowModal(true);
  };
  
  const handleShowEditModal = (student) => {
    setFormData({
      id: student.id,
      student_id: student.student_id,
      first_name: student.first_name,
      last_name: student.last_name,
      gender: student.gender || 'male',
      birth_date: student.birth_date || '',
      address: student.address || '',
      phone: student.phone || '',
      email: student.email || '',
      class_id: '',
      profile_pic: null,
      weight: student.weight || '',
      height: student.height || ''
    });
    setPreviewImage(
      student.profile_pic 
        ? `https://cms2568.backend.kruwirat.com/uploads/${student.profile_pic}` 
        : null
    );
    setFormMode('edit');
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        profile_pic: file
      });
      
      // สร้าง URL สำหรับแสดงตัวอย่างรูปภาพ
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!formData.student_id || !formData.first_name || !formData.last_name) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกรหัสนักเรียน ชื่อ และนามสกุล',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      // สร้าง FormData สำหรับส่งข้อมูลพร้อมรูปภาพ
      const data = new FormData();
      data.append('student_id', formData.student_id);
      data.append('first_name', formData.first_name);
      data.append('last_name', formData.last_name);
      data.append('gender', formData.gender);
      data.append('birth_date', formData.birth_date);
      data.append('address', formData.address);
      data.append('phone', formData.phone);
      data.append('email', formData.email);
      
      // เพิ่มข้อมูลน้ำหนักและส่วนสูง
      if (formData.weight) {
        data.append('weight', formData.weight);
      }
      
      if (formData.height) {
        data.append('height', formData.height);
      }
      
      if (formData.class_id) {
        data.append('class_id', formData.class_id);
      }
      
      if (formData.profile_pic) {
        data.append('profile_pic', formData.profile_pic);
      }
      
      let response;
      if (formMode === 'add') {
        // เพิ่มนักเรียนใหม่
        response = await api.student.createStudent(data);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มนักเรียนเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลนักเรียน
        response = await api.student.updateStudent(formData.id, data);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลนักเรียนเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowModal(false);
      fetchStudents();
    } catch (error) {
      console.error('Error saving student:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลนักเรียนได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนักเรียนนี้?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.student.deleteStudent(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลนักเรียนเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchStudents();
        } catch (error) {
          console.error('Error deleting student:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลนักเรียนได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };

  // เพิ่มฟังก์ชันเพื่อเปิด Modal ดูประวัติการเจริญเติบโต
  const handleShowGrowthModal = async (student) => {
    setSelectedStudent(student);
    setShowGrowthModal(true);
    
    try {
      setIsLoading(true);
      const response = await api.student.getStudentGrowthHistory(student.id);
      const historyData = response.data.data.growth_history || [];
      setGrowthHistory(historyData);
      
      // สร้างกราฟเมื่อมีข้อมูล
      if (historyData.length > 0) {
        setTimeout(() => {
          createGrowthChart(historyData);
        }, 300);
      }
    } catch (error) {
      console.error('Error fetching growth history:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดประวัติการเจริญเติบโตได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  // ฟังก์ชันสร้างกราฟพัฒนาการ
  const createGrowthChart = (historyData) => {
    // เตรียมข้อมูลสำหรับกราฟ
    const sortedData = [...historyData].sort((a, b) => new Date(a.record_date) - new Date(b.record_date));
    const dates = sortedData.map(record => new Date(record.record_date).toLocaleDateString('th-TH'));
    const weights = sortedData.map(record => record.weight);
    const heights = sortedData.map(record => record.height);
    
    // ทำลายกราฟเก่า (ถ้ามี)
    if (growthChart) {
      growthChart.destroy();
    }
    
    // สร้างกราฟใหม่
    const ctx = document.getElementById('growthChart');
    if (!ctx) return;
    
    const newChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'น้ำหนัก (กก.)',
            data: weights,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            yAxisID: 'y-weight'
          },
          {
            label: 'ส่วนสูง (ซม.)',
            data: heights,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            yAxisID: 'y-height'
          }
        ]
      },
      options: {
        responsive: true,
        scales: {
          'y-weight': {
            type: 'linear',
            position: 'left',
            title: {
              display: true,
              text: 'น้ำหนัก (กก.)'
            }
          },
          'y-height': {
            type: 'linear',
            position: 'right',
            title: {
              display: true,
              text: 'ส่วนสูง (ซม.)'
            },
            grid: {
              drawOnChartArea: false
            }
          }
        },
        plugins: {
          title: {
            display: true,
            text: 'กราฟแสดงพัฒนาการน้ำหนักและส่วนสูง'
          }
        }
      }
    });
    
    setGrowthChart(newChart);
  };

  // เพิ่มฟังก์ชันแปลงรูปแบบวันที่
const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  
  // ถ้าเป็นวันที่ในรูปแบบ ISO string
  if (dateString.includes('T')) {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // จะได้รูปแบบ yyyy-MM-dd
  }
  
  return dateString; // ถ้าเป็นรูปแบบอื่น ส่งคืนค่าเดิม
};
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">จัดการข้อมูลนักเรียน</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">นักเรียน</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">รายชื่อนักเรียนทั้งหมด</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={handleShowAddModal}
                  >
                    <i className="fas fa-plus"></i> เพิ่มนักเรียน
                  </button>
                </div>
              </div>
              <div className="card-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: '80px' }}>รูปภาพ</th>
                          <th style={{ width: '80px' }}>รหัส</th>
                          <th>ชื่อ-นามสกุล</th>
                          <th style={{ width: '70px' }}>เพศ</th>
                          <th style={{ width: '80px' }}>น้ำหนัก</th>
                          <th style={{ width: '80px' }}>ส่วนสูง</th>
                          <th style={{ width: '100px' }}>เบอร์โทร</th>
                          <th style={{ width: '150px' }}>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              ไม่พบข้อมูลนักเรียน
                            </td>
                          </tr>
                        ) : (
                          students.map((student) => (
                            <tr key={student.id}>
                              <td>
                                <img
                                  src={`https://cms2568.backend.kruwirat.com/uploads/${student.profile_pic}`}
                                  alt={`${student.first_name} ${student.last_name}`}
                                  className="student-profile-pic-sm"
                                  onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_AVATAR; }}
                                />
                              </td>
                              <td>{student.student_id}</td>
                              <td>
                                {student.first_name} {student.last_name}
                              </td>
                              <td>
                                {student.gender === 'male' ? 'ชาย' : 
                                 student.gender === 'female' ? 'หญิง' : 'อื่นๆ'}
                              </td>
                              <td>{student.weight ? `${student.weight} กก.` : '-'}</td>
                              <td>{student.height ? `${student.height} ซม.` : '-'}</td>
                              <td>{student.phone || '-'}</td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditModal(student)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-warning btn-sm mr-1"
                                  onClick={() => handleShowGrowthModal(student)}
                                >
                                  <i className="fas fa-chart-line"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(student.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลนักเรียน */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {formMode === 'add' ? 'เพิ่มนักเรียนใหม่' : 'แก้ไขข้อมูลนักเรียน'}
                </h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-4 text-center">
                      <div className="form-group">
                        <label>รูปโปรไฟล์</label>
                        <div className="text-center mb-2">
                          <img
                            src={previewImage || 'https://via.placeholder.com/150'}
                            alt="Preview"
                            className="student-profile-pic"
                            style={{ width: '150px', height: '150px' }}
                          />
                        </div>
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="profile_pic"
                            name="profile_pic"
                            onChange={handleFileChange}
                            accept="image/*"
                          />
                          <label className="custom-file-label" htmlFor="profile_pic">
                            เลือกรูปภาพ
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>รหัสนักเรียน <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              name="student_id"
                              value={formData.student_id}
                              onChange={handleInputChange}
                              required
                              disabled={formMode === 'edit'} // ไม่อนุญาตให้แก้ไขรหัสนักเรียนเมื่ออยู่ในโหมดแก้ไข
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>เพศ</label>
                            <select
                              className="form-control"
                              name="gender"
                              value={formData.gender}
                              onChange={handleInputChange}
                            >
                              <option value="male">ชาย</option>
                              <option value="female">หญิง</option>
                              <option value="other">อื่นๆ</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>ชื่อ <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              name="first_name"
                              value={formData.first_name}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>นามสกุล <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              name="last_name"
                              value={formData.last_name}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      
                      <div className="form-group">
                        <label>วันเกิด</label>
                        <input
                          type="date"
                          className="form-control"
                          name="birth_date"
                          value={formatDateForInput(formData.birth_date)}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* เพิ่มส่วนน้ำหนักและส่วนสูง */}
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>น้ำหนัก (กก.)</label>
                        <input
                          type="number"
                          step="0.1"
                          min="0"
                          className="form-control"
                          name="weight"
                          value={formData.weight}
                          onChange={handleInputChange}
                          placeholder="เช่น 25.5"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>ส่วนสูง (ซม.)</label>
                        <input
                          type="number"
                          step="0.1"
                          min="0"
                          className="form-control"
                          name="height"
                          value={formData.height}
                          onChange={handleInputChange}
                          placeholder="เช่น 120.5"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>เบอร์โทรศัพท์</label>
                        <input
                          type="text"
                          className="form-control"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>อีเมล</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>ที่อยู่</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>ชั้นเรียน</label>
                    <select
                      className="form-control"
                      name="class_id"
                      value={formData.class_id}
                      onChange={handleInputChange}
                    >
                      <option value="">-- เลือกชั้นเรียน --</option>
                      {classes.map((classItem) => (
                        <option key={classItem.id} value={classItem.id}>
                          {classItem.class_name} (ห้อง {classItem.room_number})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          {/* พื้นหลังทึบ */}
          <div className="modal- fade show"></div>
        </div>
      )}
      
      {/* Modal แสดงประวัติการเจริญเติบโต */}
      {showGrowthModal && selectedStudent && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  ประวัติการเจริญเติบโตของ {selectedStudent.first_name} {selectedStudent.last_name}
                </h5>
                <button type="button" className="close" onClick={() => setShowGrowthModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-4 text-center">
                        <img
                          src={`https://cms2568.backend.kruwirat.com/uploads/${selectedStudent.profile_pic}`}
                          alt={`${selectedStudent.first_name} ${selectedStudent.last_name}`}
                          className="student-profile-pic"
                          style={{ width: '120px', height: '120px' }}
                          onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/120'; }}
                        />
                        <h5 className="mt-2">{selectedStudent.first_name} {selectedStudent.last_name}</h5>
                        <p className="text-muted">รหัสนักเรียน: {selectedStudent.student_id}</p>
                      </div>
                      <div className="col-md-4">
                        <div className="info-box bg-info">
                          <span className="info-box-icon">
                            <i className="fas fa-weight"></i>
                          </span>
                          <div className="info-box-content">
                            <span className="info-box-text">น้ำหนักปัจจุบัน</span>
                            <span className="info-box-number">
                              {selectedStudent.weight ? `${selectedStudent.weight} กก.` : 'ไม่มีข้อมูล'}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-box bg-success">
                          <span className="info-box-icon">
                            <i className="fas fa-ruler-vertical"></i>
                          </span>
                          <div className="info-box-content">
                            <span className="info-box-text">ส่วนสูงปัจจุบัน</span>
                            <span className="info-box-number">
                              {selectedStudent.height ? `${selectedStudent.height} ซม.` : 'ไม่มีข้อมูล'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* กราฟพัฒนาการน้ำหนักและส่วนสูง */}
                    <div className="chart-container" style={{ height: '300px' }}>
                      <canvas id="growthChart"></canvas>
                    </div>
                    
                    <h5 className="mt-4">ประวัติการวัดน้ำหนักและส่วนสูง</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>วันที่</th>
                            <th>น้ำหนัก (กก.)</th>
                            <th>ส่วนสูง (ซม.)</th>
                            <th>บันทึกโดย</th>
                            <th>หมายเหตุ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {growthHistory.length === 0 ? (
                            <tr>
                              <td colSpan="5" className="text-center">
                                ไม่พบประวัติการเจริญเติบโต
                              </td>
                            </tr>
                          ) : (
                            growthHistory.map((record) => (
                              <tr key={record.id}>
                                <td>
                                  {new Date(record.record_date).toLocaleDateString('th-TH')}
                                </td>
                                <td>{record.weight} กก.</td>
                                <td>{record.height} ซม.</td>
                                <td>{record.recorded_by_name}</td>
                                <td>{record.note || '-'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowGrowthModal(false)}>
                  ปิด
                </button>
              </div>
            </div>
          </div>
          <div className="modal- fade show"></div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default AdminStudents;